import type { ComparativeSeller } from '../../types/comparative-report.type'

export type ComparativeMetric = 'percentage' | 'sales'
export type ComparativeOrder = 'descending' | 'ascending'

export function getComparativeValue(
  seller: ComparativeSeller,
  metric: ComparativeMetric,
): number | null {
  return metric === 'sales'
    ? seller.valorVenda
    : seller.valorCota > 0
      ? seller.porc
      : null
}

export function sortComparativeSellers(
  sellers: ComparativeSeller[],
  metric: ComparativeMetric,
  order: ComparativeOrder,
) {
  return [...sellers].sort((a, b) => {
    const first = getComparativeValue(a, metric)
    const second = getComparativeValue(b, metric)
    if (first === null && second !== null) return 1
    if (second === null && first !== null) return -1
    const difference = (first ?? 0) - (second ?? 0)
    return (
      (order === 'ascending' ? difference : -difference) ||
      a.nomeVendedor.localeCompare(b.nomeVendedor, 'pt-BR')
    )
  })
}
